<label class="field-label"><%= I18n.visit.labels.returning_patient.replace('%{provider}', provider.name) %></label>
<div class="field-content">
  <div class="input-buttons">
    <label class="input-button" role="button" tabindex="0">
      <input class="button-state" data-appointment-booking-wizard-behaviour="field-input" type="radio" name="returning_patient" value="false" <% if (!returning_patient) { %>checked<% } %>>
      <span class="button-content"><%= I18n.visit.returning_patient.new %></span>
    </label>
    <label class="input-button" role="button" tabindex="0">
      <input class="button-state" data-appointment-booking-wizard-behaviour="field-input" type="radio" name="returning_patient" value="true" <% if (returning_patient) { %>checked<% } %>>
      <span class="button-content"><%= I18n.visit.returning_patient.returning %></span>
    </label>
  </div>
</div>
